import { Pipe, PipeTransform } from "@angular/core";
import { GroupModel } from "./GroupModel";

/**
 * A simple string filter, since Angular does not yet have a filter pipe built in.
 */
@Pipe({
    name: 'selectedReport'
})
export class SelectedReportPipe implements PipeTransform{

    transform(grupos: GroupModel[]) {
        //console.log("value from pipe: ", value)
        //console.log("string fro
        return grupos.filter(grupo => grupo.selected == true);
    }
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/classes/SelectedReportPipe.ts